module.exports = __webpack_public_path__ + "6da056412d6409652a3326c9323277e5.fbx";